import styled from "styled-components"; 


export const ContainerModalToken = styled.div`
    width: 100%;
    height: 300px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    span {
        width: 90%;
        font-weight: 400;
        line-height: 150%;
        color: var(--color-latex10);
        font-size: 18px;
    }
    .btn {
        font-size: 18px;
        background-color: var( --color-broccoli);
        color: var(--color-white);
    }
`;